import { Observable } from "rxjs";
import "rxjs-compat";
import { ofType, combineEpics } from "redux-observable";
import { switchMap, map } from "rxjs/operators";
import DetailsActions from "./DetailsActions.js";
import DetailsActionTypes from "./DetailsActionTypes.js";
import FeatureResource from "@ane/exp-data/lib/resources/expapiunified/Feature.resource";
import { getAsyncWrapperFromRestResult } from "@ane/core/lib/services/RestServiceBase";
const fetchFeatureDetailEpic = (action$) => {
  return action$.pipe(
    ofType(DetailsActionTypes.FETCH_FEATURE_STATUS),
    switchMap((value) => {
      const workspaceId = value.payload.workspaceId;
      const featureIds = value.payload.featureIds;
      console.log("workspaceId:", workspaceId);
      console.log("featureIds:", featureIds);
      if (!featureIds.length)
        return Observable.empty();
      return Observable.forkJoin(featureIds.map((id) => FeatureResource.getFeature(workspaceId, id))).pipe(
        map((data) => {
          let finalData = {};
          data.forEach((d, id) => {
            finalData[featureIds[id]] = getAsyncWrapperFromRestResult(d);
          });
          return DetailsActions.updateFeatureStatusData(finalData);
        })
      );
    })
  );
};
const featureDetailsEpics = combineEpics(fetchFeatureDetailEpic);
export {
  featureDetailsEpics,
  fetchFeatureDetailEpic
};
//# sourceMappingURL=FeatureDetailsEpic.js.map
